// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';

export type ImageItem = {
  label: string;
  iconSrc: string;
};

@Component({
  selector: 'app-sharing-is-caring',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sharing-is-caring.html',
})
export class SharingIsCaring {
  public paragraphs = signal<string[]>([
    'We strongly believe that sharing is what moves the software world forward.',
    "Every Friday, we host what we call 'Learning Friday.' One or two team members dive deep into a topic they've explored and share it with the rest of the team. The topics come either from personal curiosity or from our ever-growing 'tech pool.' Things move fast in our world, and staying sharp is a team effort.",
    "Learning is not something we squeeze in when we have time. It's built into our process.",
    'Just as we learn from others, we share our own ideas, approaches, mistakes, and tools with the wider community in several ways:',
  ]);
  public listItems = signal<string[]>([
    'We publish Medium articles on topics that gave us real insights.',
    'We create open-source libraries and learning material that others can build on.',
    "We organize technical in-person events like Hacktoberfest, which we've hosted for four consecutive years, and the Practical AI Meetup.",
  ]);
  public imageItems = signal<ImageItem[]>([
    { label: 'Hacktoberfest', iconSrc: 'photo_1.webp' },
    { label: 'Practical AI Meetup', iconSrc: 'photo_2.webp' },
  ]);
}
